var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98612 18.3255L3.08613 16.4255C2.31113 15.6505 2.31113 14.3755 3.08613 13.6005L4.98612 11.7005C5.31112 11.3755 5.57362 10.738 5.57362 10.288V7.60045C5.57362 6.50045 6.47363 5.60048 7.57363 5.60048H10.2611C10.7111 5.60048 11.3486 5.33801 11.6736 5.01301L13.5736 3.11299C14.3486 2.33799 15.6236 2.33799 16.3986 3.11299L18.2986 5.01301C18.6236 5.33801 19.2611 5.60048 19.7111 5.60048H22.3986C23.4986 5.60048 24.3986 6.50045 24.3986 7.60045V10.288C24.3986 10.738 24.6611 11.3755 24.9861 11.7005L26.8861 13.6005C27.6611 14.3755 27.6611 15.6505 26.8861 16.4255L24.9861 18.3255C24.6611 18.6505 24.3986 19.288 24.3986 19.738V22.4254C24.3986 23.5254 23.4986 24.4255 22.3986 24.4255H19.7111C19.2611 24.4255 18.6236 24.688 18.2986 25.013L16.3986 26.913C15.6236 27.688 14.3486 27.688 13.5736 26.913L11.6736 25.013C11.3486 24.688 10.7111 24.4255 10.2611 24.4255H7.57363C6.47363 24.4255 5.57362 23.5254 5.57362 22.4254V19.738C5.57362 19.2755 5.31112 18.638 4.98612 18.3255Z",
    stroke: "#FC7523",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 18.75L18.75 11.25",
    stroke: "#FC7523",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1181 18.125H18.1294",
    stroke: "#FC7523",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8681 11.875H11.8794",
    stroke: "#FC7523",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.d842f4670723fef042e8bb9011701def.svg";
export { ForwardRef as ReactComponent };